import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ResultadoInconsistencia } from '../../comum/modelos/resultado-inconsistencia';

@Component({
    selector: 'app-modal-lista-inconsistencias',
    templateUrl: './modal-lista-inconsistencias.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./modal-lista-inconsistencias.component.css']
})
export class ModalListaInconsistenciasComponent implements OnInit {

    @Input() resultadoInconsistencia: ResultadoInconsistencia;

    constructor(private modalService: NgbModal) {
    }

    cadastrar(content) {
        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modalListaInconsistencias',
            size: 'lg'
        };
        this.modalService.open(content, ngbModalOptions).result.then((result) => {
        }, (reason) => {
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/coleta/modal-lista-inconsistencias/modal-lista-inconsistencias.component.ts